/* eslint-disable require-jsdoc */

import React from 'react';
import { render } from 'react-dom';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import Provider from 'react-redux/es/components/Provider';
import { ConnectedRouter, routerReducer, routerMiddleware } from 'react-router-redux';
import { ScrollContext } from 'react-router-scroll-4';
import { createMuiTheme, MuiThemeProvider } from 'material-ui/styles';
import createHistory from 'history/createBrowserHistory';
import thunk from 'redux-thunk';
import AppContainer from 'containers/App/AppContainer';
import * as reducers from './redux';
import { unregister as unregisterServiceWorker } from './utils/registerServiceWorker';
import { apiInterceptor } from 'api/interceptor';

const appReducer = combineReducers({ ...reducers, router: routerReducer });

// clear all stored state on logout
function rootReducer(state, action) {
    // if (action.type === LOGGING_OUT) {
    //     state = undefined;
    // }

    return appReducer(state, action);
}

const history = createHistory();
const historyMiddleware = routerMiddleware(history);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunk, historyMiddleware)
    )
);

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#7b0006',
        }
    }
});

// intercept api calls and handle 401 error
apiInterceptor(store.dispatch);

render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <ScrollContext>
                    <AppContainer />
                </ScrollContext>
            </ConnectedRouter>
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
);

unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js